/* Back Up The Truck Sale — loads every page of deals, then builds the department filter chips */
(function () {
  var ORDER = ['Drums', 'Guitars & Bass', 'Amps & Effects', 'Keys', 'PA, DJ & Studio', 'Accessories & More'];

  function withSection(url, sectionId) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
  }

  // Shopify serves up to 250 products per page. Fetch the remaining pages with the
  // Section Rendering API and append their cards, so the whole sale sits on one page.
  function loadRemaining(grid) {
    var sectionId = grid.getAttribute('data-section-id');
    var next = grid.getAttribute('data-next-url');
    if (!next || !sectionId || !window.fetch || !window.DOMParser) return Promise.resolve(false);
    grid.setAttribute('aria-busy', 'true');
    var seen = {};
    Array.prototype.forEach.call(grid.querySelectorAll('[data-product-id]'), function (li) {
      seen[li.getAttribute('data-product-id')] = true;
    });

    function step(url, guard) {
      if (!url || guard > 10) return Promise.resolve(true);
      return fetch(withSection(url, sectionId), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('[data-ts-grid]');
          if (!g) return true;
          Array.prototype.forEach.call(g.querySelectorAll('[data-product-id]'), function (li) {
            var id = li.getAttribute('data-product-id');
            if (seen[id]) return;
            seen[id] = true;
            grid.appendChild(document.importNode(li, true));
          });
          return step(g.getAttribute('data-next-url'), guard + 1);
        });
    }

    return step(next, 1).then(function () {
      grid.removeAttribute('aria-busy');
      grid.removeAttribute('data-next-url');
      return true;
    }, function () {
      // Leave the "More deals" link in place so customers can still page through.
      grid.removeAttribute('aria-busy');
      return false;
    });
  }

  function buildFilters(root, grid) {
    var wrap = root.querySelector('[data-ts-filters]');
    var chipsEl = root.querySelector('[data-ts-chips]');
    var brandWrap = root.querySelector('[data-ts-brand-wrap]');
    var brandSel = root.querySelector('[data-ts-brand]');
    var status = root.querySelector('[data-ts-status]');
    var noResults = root.querySelector('[data-ts-noresults]');
    var mapEl = document.getElementById('TruckSaleDepartments');
    if (!wrap || !chipsEl) return;

    var map = {};
    if (mapEl) { try { map = JSON.parse(mapEl.textContent || '{}'); } catch (e) { map = {}; } }

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-id]'));
    var deptCounts = {};
    var brands = {};   // key -> { label, count, spellings }
    cards.forEach(function (card) {
      var dept = map[card.getAttribute('data-product-id')] || '';
      card.setAttribute('data-dept', dept);
      if (dept) deptCounts[dept] = (deptCounts[dept] || 0) + 1;
      var vendor = (card.getAttribute('data-vendor') || '').trim();
      var key = vendor.toLowerCase();
      card.setAttribute('data-brand', key);
      if (!key) return;
      var b = brands[key] || (brands[key] = { count: 0, spellings: {} });
      b.count++;
      b.spellings[vendor] = (b.spellings[vendor] || 0) + 1;
    });

    var state = { dept: '', brand: '' };

    function apply() {
      var shown = 0;
      cards.forEach(function (card) {
        var match = (!state.dept || card.getAttribute('data-dept') === state.dept) &&
                    (!state.brand || card.getAttribute('data-brand') === state.brand);
        card.hidden = !match;
        if (match) shown++;
      });
      if (noResults) noResults.hidden = shown > 0;
      if (status) status.textContent = 'Showing ' + shown + ' of ' + cards.length + ' deals';
    }

    // Department chips
    var depts = ORDER.filter(function (d) { return deptCounts[d]; });
    Object.keys(deptCounts).forEach(function (d) { if (depts.indexOf(d) === -1) depts.push(d); });
    chipsEl.innerHTML = '';
    function makeChip(label, value, count) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ts-chip';
      btn.setAttribute('data-value', value);
      btn.setAttribute('aria-pressed', value === '' ? 'true' : 'false');
      btn.appendChild(document.createTextNode(label));
      var c = document.createElement('span');
      c.className = 'ts-chip__count';
      c.textContent = count;
      btn.appendChild(c);
      return btn;
    }
    if (depts.length > 1) {
      chipsEl.appendChild(makeChip('All deals', '', cards.length));
      depts.forEach(function (d) { chipsEl.appendChild(makeChip(d, d, deptCounts[d])); });
      chipsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.ts-chip');
        if (!btn) return;
        state.dept = btn.getAttribute('data-value');
        Array.prototype.forEach.call(chipsEl.children, function (c) {
          c.setAttribute('aria-pressed', c === btn ? 'true' : 'false');
        });
        apply();
      });
    } else {
      chipsEl.parentNode.hidden = true;
    }

    // Brand dropdown (labels use the most common spelling of each vendor)
    var keys = Object.keys(brands);
    if (brandSel && brandWrap && keys.length > 1) {
      keys.map(function (k) {
        var sp = brands[k].spellings;
        var label = Object.keys(sp).sort(function (a, b) { return sp[b] - sp[a]; })[0];
        return { key: k, label: label, count: brands[k].count };
      }).sort(function (a, b) {
        return a.label.localeCompare(b.label, 'en', { sensitivity: 'base' });
      }).forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o.key;
        opt.textContent = o.label + ' (' + o.count + ')';
        brandSel.appendChild(opt);
      });
      brandWrap.hidden = false;
      brandSel.addEventListener('change', function () {
        state.brand = brandSel.value;
        apply();
      });
    }

    wrap.hidden = false;
    apply();
  }

  function init(root) {
    var grid = root.querySelector('[data-ts-grid]');
    if (!grid || root.hasAttribute('data-ts-ready')) return;
    root.setAttribute('data-ts-ready', '');
    loadRemaining(grid).then(function (loadedAll) {
      if (loadedAll) {
        var more = root.querySelector('[data-ts-more]');
        if (more) more.hidden = true;
      }
      buildFilters(root, grid);
    });
  }

  function boot() {
    document.querySelectorAll('.ts').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
